import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageIdentityHeaderCIC from "./UserPageIdentityHeaderCIC";
export default function UserPageIdentityHeader(t0) {
  const $ = _c(3);
  const {
    profile
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-mb-6"><h2 className="tw-mb-1 tw-text-xl tw-font-semibold tw-text-iron-100">Network Identity Check (NIC)</h2><p className="tw-mb-0 tw-text-iron-500 tw-text-sm tw-font-normal tw-leading-relaxed">Does the network believe this profile accurately represents its identity?</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== profile) {
    t2 = <div className="tw-px-6 tw-pt-6">{t1}<UserPageIdentityHeaderCIC profile={profile} /></div>;
    $[1] = profile;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}